document.addEventListener("DOMContentLoaded", yall);

document.addEventListener("DOMContentLoaded", function () {
	/* GLOBAL */


	// ADD REL=0 for all YOUTUBE VIDEOS
	var parser, iframe;
	iframe = document.querySelectorAll('iframe[src*="youtube.com"]');
	parser = document.createElement("a");
	iframe.forEach(function (iframe_node) {
		var node_src, search;
		node_src = iframe_node.getAttribute("src");
		parser.href = node_src;
		console.log();
		search = parser.search.substr(1);
		search = search.replace(/&?rel=([0-1])/g, "");
		parser.search = search.length > 0 ? search + "&rel=0" : "?rel=0";
		iframe_node.setAttribute("src", parser.href);
	});

	const nav = document.querySelector("#nav");
	const modalElements = [".video-modal", ".modal-overlay", ".modal-exit"];

	document.addEventListener("scroll", scrollListener);

	document
		.querySelector(".hamburger")
		.addEventListener("click", toggleMobileMenu);

	document.querySelectorAll('a.open-modal').forEach( function (add_button) {
		add_button.addEventListener('click', function (e) {
			e.preventDefault();

			// Find a.modal and grab data-src
			let videoSource;
			videoSource = e.currentTarget.getAttribute('data-src')
			console.log('video source:', videoSource);

			openModal(videoSource);
		});
	});

	document.querySelector("#close-modal").addEventListener("click", closeModal);

	document
		.querySelector(".modal-overlay")
		.addEventListener("click", closeModal);

	document
		.querySelector("#exterior")
		.addEventListener("mouseover", function () {
			document.querySelector("#exterior-dropdown").classList.remove("hidden");
			document.querySelector("body").classList.add("stop-scroll");
		});
	document.querySelector("#exterior").addEventListener("mouseout", function () {
		document.querySelector("#exterior-dropdown").classList.add("hidden");
		document.querySelector("body").classList.remove("stop-scroll");
	});

	document
    .querySelector("#interior")
    .addEventListener("mouseover", function () {
      document.querySelector("#interior-dropdown").classList.remove("hidden");
      document.querySelector("body").classList.add("stop-scroll");
    });
  document.querySelector("#interior").addEventListener("mouseout", function () {
    document.querySelector("#interior-dropdown").classList.add("hidden");
    document.querySelector("body").classList.remove("stop-scroll");
  });

	document
    .querySelector("#accessories")
    .addEventListener("mouseover", function () {
      document.querySelector("#accessories-dropdown").classList.remove("hidden");
      document.querySelector("body").classList.add("stop-scroll");
    });
  document.querySelector("#accessories").addEventListener("mouseout", function () {
    document.querySelector("#accessories-dropdown").classList.add("hidden");
    document.querySelector("body").classList.remove("stop-scroll");
  });

	// // Navigation Search Bar toggle
	// document
	// 	.querySelector(".alt-nav__menu-item .icon-zoom")
	// 	.addEventListener("click", toggleNavSearch);
	// document
	// 	.querySelector("#cancel-search")
	// 	.addEventListener("click", function (e) {
	// 		e.preventDefault();
	// 		toggleNavSearch();
	// 	});

	function toggleNavSearch() {
		const search = document.querySelector(".alt-nav__menu-item .search");
		search.classList.toggle("hide");
		if (!search.classList.contains("hide")) {
			document.querySelector(".search>input[type=text]").focus();
		}
	}

	// Event listener for caret down/up on alt images on product page
	if (document.querySelector(".alt-image-nav")) {
		document
			.querySelector(".alt-image-nav>.icon-caret-down")
			.addEventListener("click", function () {
				scrollOnClick();
			});

		document
			.querySelector(".alt-image-nav>.icon-caret-up")
			.addEventListener("click", function () {
				scrollOnClick(true);
			});
	}
	// event listener for hovering over alt images on product page
	const productImage = document.querySelector("#product-image");
	const lightbox = document.querySelector(".lightbox");
	const hoverImage = document.querySelector("#hover-image");
	const hoverImageWrapper = document.querySelector(".hover-image-wrapper");
	document.querySelectorAll(".alt-image").forEach(function (elem) {
		elem.addEventListener("click", function () {
			productImage.src = elem.src;
		});
		elem.addEventListener("mouseover", function () {
			productImage.style.display = "none";
			hoverImageWrapper.style.display = "flex";
			hoverImage.src = elem.src;
		});
		elem.addEventListener("mouseout", function () {
			productImage.style.display = "block";
			hoverImageWrapper.style.display = "none";
		});
	});

	// Product Image Lightbox Open
	if ( productImage ) {
		productImage.addEventListener("click", function() {
			document.querySelector(".lightbox").classList.remove("hidden");
			document.querySelector(".lightbox__image>img").src = productImage.src;
			document.querySelector("body").classList.add("stop-scroll");
		});
	}
	// Product Image Lightbox Close
	if ( lightbox ) {
		lightbox.addEventListener("click", function () {
			document.querySelector(".lightbox").classList.add("hidden");
			document.querySelector("body").classList.remove("stop-scroll");
		});
	}

	function scrollOnClick(up) {
		const image = document.querySelector(".alt-image-wrapper");
		const style = window.getComputedStyle(image);
		const height = parseInt(style.height.split(".")[0]);
		const marginBottom = parseInt(style.marginBottom.split(".")[0]);
		const container = document.querySelector(".product-alt-images");
		if (up) {
			container.scrollBy({
				top: -(height + marginBottom),
				behavior: "smooth",
			});
			return;
		}
		container.scrollBy({
			top: height + marginBottom,
			behavior: "smooth",
		});
	}



	function openModal(src) {
		const videoModal = document.querySelector('.video-modal');
		if (videoModal.innerHTML === "") {
			videoModal.innerHTML = `<iframe id="video" data-src="https://www.youtube.com/embed/1PCQasthqmU/?autoplay=1&rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>`;
		}
		const video = document.querySelector("#video");
		video.setAttribute("data-src", src);
		video.src = src + "?autoplay=1&rel=0";
		document.querySelector("body").classList.add("stop-scroll");
		modalElements.forEach(function (elem) {
			document.querySelector(elem).classList.add("active");
		});
	}

	function closeModal() {
		const video = document.querySelector("#video");
		const videoModal = document.querySelector('.video-modal');
		videoModal.innerHTML = "";
		//video.src = 'https://www.youtube.com/embed/1PCQasthqmU/';
		//video.setAttribute('data-src', 'https://www.youtube.com/embed/1PCQasthqmU/');
		document.querySelector("body").classList.remove("stop-scroll");
		modalElements.forEach(function (elem) {
			document.querySelector(elem).classList.remove("active");
		});

		console.log(video)

	}

	function scrollListener() {
		if (window.scrollY > 450 && !nav.classList.contains("sticky")) {
			nav.classList.add("sticky", "transition");

			setTimeout(function () {
				nav.classList.remove("transition");
			}, 0);
		} else if (window.scrollY <= 10 && nav.classList.contains("sticky")) {
			nav.classList.remove("sticky");
		}
	}

	function toggleMobileMenu() {
		document.querySelector(".hamburger").classList.toggle("active");
		document.querySelector(".nav-row ul").classList.toggle("active");
	}

	//Event listener for Ceramic Tutorial
	var ceramicTutorial = document.getElementById("ceramicTutorial") !== null;
	if(ceramicTutorial ) {
		ceramicTutorial.addEventListener("click", function () {
			openModal("https://www.youtube.com/embed/KJ0PmfaIH3o/");
		});
	}
});

//Product 2022 Scripts
	function reviewReveal() {
    let review = document.getElementById("review-section");
    review.classList.remove("d-none");
  }
  function tabSelector(e) {
    // Get the selected tab
    let tabOption = e.target;

    // Get the other sibling tabs
    otherTabs = getSiblings(tabOption.parentNode);

    // Go through all tabs and make sure that only the tab that was clicked has the selected-tab class
    tabOption.parentNode.classList.add("selected-tab");
    for (let indexOfTabs = 0; indexOfTabs < otherTabs.length; indexOfTabs++) {
      const otherTab = otherTabs[indexOfTabs];
      otherTab.classList.remove("selected-tab");
    }

    // Get a list of all the panels
    panelElements = document.getElementsByClassName("toggle-panel");

    // Go through them one by one and check only apply the hidden class to the panels not selected
    for (
      let indexOfSelection = 0;
      indexOfSelection < panelElements.length;
      indexOfSelection++
    ) {
      const panel = panelElements[indexOfSelection];
      if (indexOfSelection == tabOption.attributes.value.value) {
        panel.classList.remove("d-none");
      } else {
        panel.classList.add("d-none");
      }
    }
  }
  function getSiblings(e) {
    let siblings = [];

    if (!e.parentNode) {
      return siblings;
    }

    let sibling = e.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }
	//Product 2022 Script End

// Email Subscribe Popup *** TO DO: REFACTOR VARIABLES & EVENT LISTENERS
/*
document.addEventListener("DOMContentLoaded", function () {
	let thank_you_title = "You're on the list!";
	let thank_you_message = "Please check your email for your new code!";

	if( document.cookie.indexOf( "ModalShown=true" ) < 0 ) {
		document.querySelector("#subscribe-modal").classList.add("active");
		document.querySelector("#subscribe-modal-overlay").classList.add("active");

		//Modal has been shown, now set event listener for close button
		document.querySelector("#subscribe-close").addEventListener( "click", function() {
			document.querySelector("#subscribe-modal").classList.remove("active");
			document.querySelector("#subscribe-modal-overlay").classList.remove("active");
		});

		//Show thank you message
		document.querySelector("#mc-embedded-subscribe").addEventListener("click", function(){
			document.querySelector("#subscribe-modal h2").innerHTML = thank_you_title;

			// Get the parent element
			let parentElement = document.querySelector("#mc_embed_signup");

			// Get the parent's first child
			let theFirstChild = parentElement.firstChild;

			// Create a new element
			let newElement = document.createElement("p");
			newElement.innerHTML = thank_you_message;

			// Insert the new element before the first child
			parentElement.insertBefore(newElement, theFirstChild);

			document.querySelector("#subscribe-close").innerHTML = "Close";
		}, false);

			//Now set a cookie so it never comes back
		document.cookie = "ModalShown=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
	}
});
*/
